import { createContext, Dispatch, SetStateAction } from "react";
import { LayoutMode } from "../../enums/LayoutMode";

/**
 * --- Interfaces ---
 */
export interface ILayoutModeContext {
    mode: LayoutMode,
    setMode: Dispatch<SetStateAction<LayoutMode>>;
}

/**
 * --- Layout Context ---
 */
export const LayoutModeContext = createContext<ILayoutModeContext>({
    mode: LayoutMode.Default,
    setMode: () => {}
})